import React from "react";

export const LocationDetails = () => {
  return (
    <div className="contact-page__right">
      <h5 className="title-program text-contact-gray font-montserrat text-[18px] font-bold mt-0 mb-[10px]">
        Program magazin
      </h5>
      <div className="program-magazin pl-[23px] pt-[22px] border border-contact-gray">
        <div>
          <span className="text-contact-gray font-montserrat text-[18px] leading-[37px]">Luni-Vineri: </span>
          <span className="ctc-numar text-price-color font-montserrat text-[18px] leading-[37px]">8:30 - 17:30</span>
        </div>
        <div>
          <span className="text-contact-gray font-montserrat text-[18px] leading-[37px]">Sâmbătă: </span>
          <span className="ctc-numar text-price-color font-montserrat text-[18px] leading-[37px]">Închis</span>
        </div>
        <div>
          <span className="text-contact-gray font-montserrat text-[18px] leading-[37px]">Duminică: </span>
          <span className="ctc-numar text-price-color font-montserrat text-[18px] leading-[37px]">Închis</span>
        </div>
        <p className="leading-[37px] text-contact-gray font-montserrat text-[14px]">(Sâmbătă - Duminică nu se preiau comenzi telefonice)</p>
      </div>
      <h5 className="text-contact-gray font-montserrat text-[18px] font-bold mt-[26px] mb-[15px]">Locații</h5>
      <div className="adresa-pct-principal pl-[23px] pt-[22px] pb-[22px] border border-contact-gray mb-[28px]">
        <div>
          <span className="text-contact-gray font-montserrat text-[18px] leading-[37px]">Strada: </span>
          <span className="black text-price-color font-montserrat text-[18px] leading-[37px]">Strandului nr. 70,</span>
        </div>
        <div>
          <span className="text-contact-gray font-montserrat text-[18px] leading-[37px]">Cod postal: </span>
          <span className="black text-price-color font-montserrat text-[18px] leading-[37px]">100189,</span>
        </div>
        <div>
          <span className="text-contact-gray font-montserrat text-[18px] leading-[37px]">Oras: </span>
          <span className="black text-price-color font-montserrat text-[18px] leading-[37px]">Ploiesti, judet: Prahova</span>
        </div>
        <div>
          <span className="text-contact-gray font-montserrat text-[18px] leading-[37px]">Orientare: </span>
          <span className="black text-price-color font-montserrat text-[18px] leading-[37px]">DN 1B, Sos. Ploiesti-Buzau</span>
        </div>
      </div>
      <div className="embed-yt w-auto">
        <iframe
          style={{ border: 0 }}
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11293.020807741661!2d26.0555507!3d44.9588068!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x92c9c2e58b625d39!2sMagazia+Lu'+Costica!5e0!3m2!1sro!2sro!4v1473745445391"
          height="530"
          width="100%"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Magazia Lu' Costica"
        ></iframe>
      </div>
    </div>
  )
}